import api from "./api";

export async function connectIntegration(integrationData) {

    const response = await api.post(
        "/api/v1/shopify/connect-integration",
        integrationData
    );

    return response.data;

}